// 政务一体化后台基础路由
import BasicLayout from '../layouts/BasicLayout'

export default [
  {
    path: '/',
    redirect: '/dashboard/home',
    component: BasicLayout,
    children: [
      {
        path: '/dashboard/home',
        component: () => import('../views/dashboard/Home'),
        meta: {title: '首页'}
      },
      {
        path: '/dashboard/design',
        component: () => import('../views/dashboard/Design'),
        meta: {title: '自定义'}
      }
    ]
  },
  {
    path: '/login',
    meta: {title: '登录页', requireAuth: false},
    component: () => import('../views/Login')
  }
]